import {Text} from '@/components-v2/atoms/Text/Text'
import {useProductReview} from '../../../context/ProductReviewContext'
import {ProductReviewField} from '../../ui/ProductReviewField'
import {ProductReviewSection} from '../../ui/ProductReviewSection'

/**
 * @param {{section: import('./taxesAndSalesDataMap').TaxesAndSalesSectionConfig}} props
 */
export const TaxesAndSalesSection = ({section}) => {
  const {productData} = useProductReview()
  const sectionItems = productData?.[section.source] ?? []

  return (
    <ProductReviewSection title={section.title}>
      <div className="flex flex-col divide-y divide-gray-200">
        {sectionItems.length > 0 ? (
          sectionItems.map((item, index) => (
            <div key={`${section.id}-${index}`} className="flex flex-col gap-2 py-4">
              <Text variant="bold" className="block text-sm">
                {section.itemLabel} {index + 1}
              </Text>
              <div className="divide-y divide-[var(--secondary-800)]">
                {section.fields.map(field => {
                  const value = field.formatValue ? field.formatValue(item) : item?.[field.key]

                  return (
                    <ProductReviewField
                      key={`${section.id}-${index}-${field.key}`}
                      label={field.label}
                      editable={false}
                      required={false}
                      renderer="text"
                      value={value}
                    />
                  )
                })}
              </div>
            </div>
          ))
        ) : (
          <Text variant="medium">-</Text>
        )}
      </div>
    </ProductReviewSection>
  )
}
